// Display name shown to users across the agent chat UI.
export const AGENT_NAME = 'ARIA';

// Window dimensions
export const DEFAULT_WINDOW_WIDTH = 522;
export const DEFAULT_WINDOW_HEIGHT = 600;
export const MIN_WINDOW_WIDTH = 420;
export const MIN_WINDOW_HEIGHT = 300;
export const DEFAULT_DRAWER_WIDTH = 522;
export const MIN_DRAWER_WIDTH = 420;
export const MAX_DRAWER_WIDTH = 1569;

// Queued-message list
export const QUEUE_ROW_HEIGHT = 46; // 32px content + 12px padding + 2px border
export const QUEUE_MAX_HEIGHT = QUEUE_ROW_HEIGHT * 4 + 4 * 3; // 4 rows + 4px gaps
// MIN_THREAD_HEIGHT floors the thread viewport while a queue is present, so
// queued messages can't push the conversation out of view.
export const MIN_THREAD_HEIGHT = 160;

// Terminal tool calls

// Name of the terminal ask_user tool (mirrors ASK_USER_TOOL.name in the
// backend). Its call ends the turn and is never dispatched to the environment,
// so it has no result — rendered as a plain indicator, not a tool-call row.
export const ASK_USER_TOOL_NAME = 'ask_user';

// Name of the terminal request_network_access tool (mirrors
// REQUEST_NETWORK_ACCESS_TOOL.name in the backend). Like ask_user it ends the
// turn with no result, so it renders as an indicator, not an error tool-call row.
export const REQUEST_NETWORK_ACCESS_TOOL_NAME = 'request_network_access';

export const NON_COLLAPSIBLE_TOOLS = [
  ASK_USER_TOOL_NAME,
  REQUEST_NETWORK_ACCESS_TOOL_NAME,
];
